import { Component, input } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
interface EventItem {
  note?: string;
  title?: string;
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
}

@Component({
  selector: 'app-notes',
  standalone: true,
  imports: [TimelineModule, CardModule, ButtonModule],
  templateUrl: './notes.component.html',
  styleUrl: './notes.component.scss',
})
export class NotesComponent {
  readonly data = input<EventItem[]>([]);
}
